import  { useEffect, useState } from "react";
import AppRouter from "./Router/AppRouter";
import Loader from "./components/Loader/Loader";
import heroImage from "./components/BgHome/img/bg.jpg";

const App = () => {
  const [isAppReady, setIsAppReady] = useState(false);

  useEffect(() => {
    const image = new Image();
    image.src = heroImage;

    const handleReady = () => {
      setIsAppReady(true);
    };

    if (image.complete) {
      handleReady();
    } else {
      image.onload = handleReady;
      image.onerror = handleReady;
    }

    return () => {
      image.onload = null;
      image.onerror = null;
    };
  }, []);

  if (!isAppReady) {
    return <Loader />;
  }

  return <AppRouter />;
};

export default App;
